import { render, staticRenderFns } from "./expertsList.vue?vue&type=template&id=2c2c88d1&scoped=true&"
import script from "./expertsList.vue?vue&type=script&lang=js&"
export * from "./expertsList.vue?vue&type=script&lang=js&"
import style0 from "./expertsList.vue?vue&type=style&index=0&id=2c2c88d1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c88d1",
  null
  
)

export default component.exports